/**
 * « Ce que je suis » — accueil de l'habitant (chantier 7, étape 4, maquette 18).
 * Ses démarches EN COURS (signalements, urbanisme, locations), et le lien vers
 * « Tout mon suivi ». Même source que la page complète (lib/suivi-habitant).
 */
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { chargerSuivi, TON_CLASSE, type LigneSuivi } from '@/lib/suivi-habitant';

export function MesDemarchesCard() {
  const [lignes, setLignes] = useState<LigneSuivi[] | null>(null);
  useEffect(() => { void chargerSuivi().then((l) => setLignes(l.filter((x) => x.enCours))); }, []);
  return (
    <section aria-label="Ce que je suis" className="mt-4 rounded-r-xl border border-border bg-surface/55 p-4">
      <div className="mb-1 flex items-center">
        <h2 className="flex-1 text-base font-semibold text-ink">Ce que je suis</h2>
        <Link to="/mon-suivi" className="text-sm text-accent hover:underline">Tout mon suivi →</Link>
      </div>
      {lignes && lignes.length === 0 && <p className="py-2 text-sm text-ink-muted">Aucune démarche en cours.</p>}
      <ul>
        {(lignes ?? []).slice(0, 5).map((l) => (
          <li key={l.id} className="border-t border-border/60 first:border-t-0">
            <Link to={l.lien} className="flex items-center gap-3 py-3 text-sm text-ink hover:text-accent">
              <span className="min-w-0 flex-1 truncate">{l.titre}</span>
              <span className={`flex-shrink-0 rounded-r-pill px-2.5 py-0.5 text-2xs font-medium ${TON_CLASSE[l.ton]}`}>{l.statut}</span>
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
}
